import React from 'react';
import Marquee from 'react-fast-marquee';

const MarqueeRibbon = () => {
  const items = [
    'Retouches de Vêtements',
    'Retouches de Rideaux',
    'Ourlets & Ajustements',
    'Savoir-faire Français',
    'Service Personnalisé',
    'Réparations Textiles'
  ];

  return (
    <div className="py-6 bg-[#F5F5F0] border-y border-[#E8D5D1]/30 overflow-hidden" data-testid="marquee-ribbon">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span 
            key={i} 
            className="mx-12 text-2xl sm:text-3xl font-light text-[#D4AF37]/50 italic"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {item} <span className="mx-6 text-[#D4AF37]/30">&#8226;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeRibbon;
